// Shared labels & option constants
export const STAGE_LABELS = {
  prospect: "Prospect",
  contacted: "Contacted",
  in_discussion: "In Discussion",
  empanelled: "Empanelled",
  rejected: "Rejected",
};
export const STAGE_ORDER = ["prospect", "contacted", "in_discussion", "empanelled", "rejected"];
export const STAGE_COLORS = {
  prospect: "bg-slate-100 text-slate-700 border-slate-200",
  contacted: "bg-blue-100 text-blue-800 border-blue-200",
  in_discussion: "bg-amber-100 text-amber-800 border-amber-200",
  empanelled: "bg-emerald-100 text-emerald-800 border-emerald-200",
  rejected: "bg-rose-100 text-rose-700 border-rose-200",
};

export const JOB_STATUS_LABELS = {
  enquiry: "Enquiry",
  job_assigned: "Job Assigned",
  docs_collected: "Documents Collected",
  field_team: "Field Team",
  report_writer: "Report Writer",
  draft_data_in: "Draft Data In",
  draft_prepared: "Draft Prepared",
  admin_review: "Admin Review",
  sent_to_client: "Sent to Client",
  client_approved: "Client Approved",
  invoiced: "Invoiced",
  report_released: "Report Released",
  completed: "Completed",
};
export const JOB_STATUS_ORDER = ["enquiry", "job_assigned", "docs_collected", "field_team", "report_writer", "draft_data_in", "draft_prepared", "admin_review", "sent_to_client", "client_approved", "invoiced", "report_released", "completed"];
export const JOB_STATUS_COLORS = {
  enquiry: "bg-slate-100 text-slate-700 border-slate-200",
  job_assigned: "bg-blue-100 text-blue-800 border-blue-200",
  docs_collected: "bg-sky-100 text-sky-800 border-sky-200",
  field_team: "bg-violet-100 text-violet-800 border-violet-200",
  report_writer: "bg-purple-100 text-purple-800 border-purple-200",
  draft_data_in: "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-200",
  draft_prepared: "bg-amber-100 text-amber-800 border-amber-200",
  admin_review: "bg-indigo-100 text-indigo-800 border-indigo-200",
  sent_to_client: "bg-cyan-100 text-cyan-800 border-cyan-200",
  client_approved: "bg-teal-100 text-teal-800 border-teal-200",
  invoiced: "bg-orange-100 text-orange-800 border-orange-200",
  report_released: "bg-lime-100 text-lime-800 border-lime-200",
  completed: "bg-emerald-100 text-emerald-800 border-emerald-200",
};
// Legacy status keys kept so old jobs still render a label/color until migrated
export const LEGACY_JOB_STATUS = {
  new: "enquiry", assigned: "job_assigned", site_visit: "field_team",
  report_writing: "draft_prepared", internal_qc: "admin_review",
  submitted: "sent_to_client", query_revision: "admin_review",
};

export const ROLE_LABELS = {
  owner: "Owner",
  report_writer: "Report Writer",
  field_executive: "Field Executive",
  accountant: "Accountant",
};

export const PROPERTY_TYPES = ["Residential", "Commercial", "Industrial", "Agricultural", "Plot / Land", "Under Construction", "Mixed Use"];

export const JOB_PURPOSES = ["Mortgage", "Insurance", "Fair Market Value", "Sale", "Capital Gains", "Other"];

export const CLIENT_TYPES = ["Individual", "Builder / Developer", "Company", "Bank", "Other"];
export const CLIENT_TAGS = ["Individual", "Corporate", "HNI", "Repeat Client", "Referral Source"];
export const CLIENT_CATEGORIES = ["Bank Initiated", "CA Initiated", "Self Initiated"];
export const KYC_STATUS = ["pending", "verified", "incomplete"];

export const BANK_CATEGORIES = ["PSU", "Private", "Cooperative", "NBFC", "Unclassified"];
export const EMPANELMENT_STATUS = {
  not_empanelled: "Not Empanelled",
  applied: "Applied",
  active: "Active",
  expired: "Expired",
};

export const INVOICE_STATUS_LABELS = { draft: "Draft", sent: "Sent", paid: "Paid", overdue: "Overdue", cancelled: "Cancelled" };
export const INVOICE_STATUS_ORDER = ["draft", "sent", "paid", "overdue", "cancelled"];
export const INVOICE_STATUS_COLORS = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  sent: "bg-amber-100 text-amber-800 border-amber-200",
  paid: "bg-emerald-100 text-emerald-800 border-emerald-200",
  overdue: "bg-rose-100 text-rose-700 border-rose-200",
  cancelled: "bg-zinc-100 text-zinc-600 border-zinc-200",
};

export const PAYMENT_MODES = ["NEFT", "RTGS", "IMPS", "UPI", "Cheque", "Cash", "Razorpay"];

export const FOLLOWUP_TYPES = {
  payment: "Payment Reminder",
  document: "Document Pending",
  site_visit: "Site Visit Reminder",
  callback: "Client Callback",
  bank_query: "Bank Query",
  empanelment: "Empanelment Renewal",
  report_delivery: "Report Delivery",
  other: "Other",
};

export const CAMPAIGN_AUDIENCES = {
  dormant_branches: "Dormant branches (60+ days no work)",
  empanelment_renewals: "Empanelments due for renewal",
  new_branches: "New branches in our regions",
  past_clients: "Past clients (referrals)",
};
export const CAMPAIGN_CHANNELS = ["email", "whatsapp", "sms"];
export const RECIPIENT_STATUS = {
  no_response: "No Response",
  opened: "Opened",
  replied: "Replied",
  converted: "Converted to Job",
};

export const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;

// Bank short-forms → canonical name, mirrored from backend so "sbi" and
// "State Bank of India" share the same report template.
const BANK_ALIASES = {
  sbi: "State Bank of India", "state bank": "State Bank of India",
  bob: "Bank of Baroda", pnb: "Punjab National Bank",
  boi: "Bank of India", ubi: "Union Bank of India",
  cbi: "Central Bank of India", iob: "Indian Overseas Bank",
  hdfc: "HDFC Bank", icici: "ICICI Bank", idbi: "IDBI Bank",
  idfc: "IDFC First Bank", kotak: "Kotak Mahindra Bank",
  rbl: "RBL Bank", psb: "Punjab & Sind Bank",
  "jk bank": "Jammu & Kashmir Bank", "j k bank": "Jammu & Kashmir Bank",
  "au sfb": "AU Small Finance Bank", scb: "Standard Chartered Bank",
};
const bankNorm = (name) => (name || "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim().replace(/\s+/g, " ");
export const bankKey = (name) => {
  const n = bankNorm(name);
  const ns = n.replace(/ /g, "");
  const aliasMap = {};
  Object.entries(BANK_ALIASES).forEach(([k, v]) => { aliasMap[bankNorm(k)] = v; });
  const aliasStripped = {};
  Object.entries(aliasMap).forEach(([k, v]) => { aliasStripped[k.replace(/ /g, "")] = v; });
  const canonical = aliasMap[n] || aliasStripped[ns] || (name || "").trim();
  return bankNorm(canonical).replace(/ /g, "") || ns;
};
